import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { isEmpty, isArray, isUndefined } from 'lodash';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import qs from 'querystring';
import { Input } from '~/components/Form';
import AprovarFaturametoDialogGFE from './AprovarFaturametoDialogGFE';
import ListTransfer from '../ListTransfer';

import { t } from '~/helpers';
import api from '~/services/api';
import * as S from './styles';

export default function MyForm({ data, reference, close, cancelarAcao }) {

  const { profile } = useSelector((state) => state.user);

  const [isLoading, setIsLoading] = useState(false);
  const [totalRegistros, setTotalRegistros] = useState(0);

  const [empenho, setEmpenho] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");


  const [units, setUnits] = useState([]);
  const [faturas, setFaturas] = useState([]);

  const handleGetSenario = React.useCallback(async () => {
    const wherefield = [];
    const valuewherefield = [];
    const typewherefield = [];

    wherefield.push('fatu_status');
    valuewherefield.push("201, 202");
    typewherefield.push("IN");
    const search = { wherefield, valuewherefield, typewherefield };


    try {
      const { data } = await api.get('/radadmdadosfaturamentoseplag', {
        params: { ...search, pagesize: 99999, pesquisalista: true, page: 1, },
        paramsSerializer: (param) => qs.stringify(param),
      });

      if (!isEmpty(data)) {
        setFaturas(data.items);
        setTotalRegistros(data.totalCount); //Total de registros
      } else {
        setFaturas([]);
        setTotalRegistros(0); //Total de registros
      }

    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      // setLoad(false);
    }
  }, []);


  const cells = useMemo(
    () => [
      { id: 'fatu_codigo', label: 'Pré-fatura' },
      { id: 'orga_nome', label: 'Órgão' },
    ],
    []
  );

  //ConfirmationDialogRaw o registro do geral
  const [tituloConfirmationDialogRaw, setTituloConfirmationDialogRaw] = React.useState('RESUMO DO FATURAMENTO!');
  const [mensagemConfirmationDialogRaw, setMensagemConfirmationDialogRaw] = React.useState('Deseja confirmar a operação?');
  const [openConfirmationDialogRaw, setOpenConfirmationDialogRaw] = React.useState(false);
  const [valueConfirmationDialogRaw, setValueConfirmationDialogRaw] = React.useState("CLICK-OK");
  const [paramSubmit, setParamSubmit] = React.useState();

  // Initial data
  useEffect(() => {
    handleGetSenario();
  }, []);

  const execHandleConfirmar = async (param) => {
    try {
      const wherefield = [];
      const valuewherefield = [];
      const typewherefield = [];
      wherefield.push('usua_login');
      valuewherefield.push(username);
      typewherefield.push("IGUAL");
      const search = { wherefield, valuewherefield, typewherefield };
      const { data } = await api.get('/usuariomaster', {
        params: { ...search, pagesize: 99999, pesquisalista: true, page: 1, },
        paramsSerializer: (param) => qs.stringify(param),
      });
      const { items } = data;
      if (!isEmpty(items)) {


        let glousuariologin = profile.glousuariologin;
        if (isUndefined(glousuariologin)) {
          glousuariologin = username;
        }
        if ((String(glousuariologin).trim().toUpperCase()) !== (String(username).trim().toUpperCase())) {
          toast.error('O login informado é diferente do que foi utilizado para acessar o sistema!');
          return;
        }


        if (password !== items[0].usua_senha) {
          toast.error('Falha na autenticação do usuário! Login ou senha inválidos!');
          return;
        }
        if (items[0].usua_aprova_pre_faturamento === 'N') {
          toast.error('Falha na autenticação do usuário! Sem permissão para essa operação!');
          return;
        }
        if (items[0].usua_status !== 1) {
          toast.error('Falha na autenticação do usuário! Usuário bloqueado!');
          return;
        }
        if (items[0].perf_status !== 1) {
          toast.error('Falha na autenticação do usuário! Usuário bloqueado!');
          return;
        }
      } else {
        toast.error('Falha na autenticação do usuário! Login ou senha inválidos!');
        return;
      }
    } catch (err) {
      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }
    }
    setParamSubmit(param);
    setOpenConfirmationDialogRaw(true);
  };

  const handleConfirmationDialogRaw = (recordResultDialog) => {
    setOpenConfirmationDialogRaw(false);
    if (recordResultDialog) {
      setValueConfirmationDialogRaw(recordResultDialog.acao);
      setIsLoading(false);
      if (recordResultDialog.acao === 'CLICK-OK') {
        setIsLoading(true);
        handleSubmit(paramSubmit, recordResultDialog)
      }
    } else {
      cancelarAcao();
      setIsLoading(false);
    }
  };

  async function handleSubmitPegunta(param) {

    try {
      let sparam = {
        ...param
      }
      const schema = Yup.object().shape({
        empenho: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, 'Este campo deve ter no mínimo 1 caractere(s)')
          .max(20, 'Este campo deve ter no maximo 20 caractere(s)'),
        username: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, 'Este campo deve ter no mínimo 1 caractere(s)')
          .max(20, 'Este campo deve ter no maximo 20 caractere(s)'),
        password: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, 'Este campo deve ter no mínimo 1 caractere(s)')
          .max(20, 'Este campo deve ter no maximo 20 caractere(s)'),
      });

      await schema.validate(sparam, {
        abortEarly: false,
      });

      if (isEmpty(units)) {
        toast.error('Lista de pré-faturas selecionadas está vazia!');
        return;
      };
      await setIsLoading(true);
      await execHandleConfirmar(param);
    } catch (err) {
      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });
        reference.current.setErrors(validationErrors);
      }
    }
  }

  async function handleSubmit(param, recordResultDialog) {
    try {
      let sparam = {
        ...param
      }
      const schema = Yup.object().shape({
        empenho: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, 'Este campo deve ter no mínimo 1 caractere(s)')
          .max(20, 'Este campo deve ter no maximo 20 caractere(s)'),
        username: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, 'Este campo deve ter no mínimo 1 caractere(s)')
          .max(20, 'Este campo deve ter no maximo 20 caractere(s)'),
        password: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, 'Este campo deve ter no mínimo 1 caractere(s)')
          .max(20, 'Este campo deve ter no maximo 20 caractere(s)'),
      });

      await schema.validate(sparam, {
        abortEarly: false,
      });

      const faturamentoseparados = units.map(obj1 => (
        {
          fatu_codigo: obj1.fatu_codigo,
          orga_codigo: obj1.orga_codigo,
          orga_nome: obj1.orga_nome,
          fatu_uuid: obj1.fatu_uuid
        }));

      // console.log(JSON.stringify(faturamentoseparados));

      const objSend = {
        faturamentoseparados: faturamentoseparados,
        empenho: param.empenho,
        username01: param.username,
        password01: param.password,
        username02: recordResultDialog.login,
        password02: recordResultDialog.senha,
      };

      await api.put('radadmdadosfaturamentoseplag/criarfaturasgfe', objSend);
      toast.success(t('s.geral.sucessoalteracao'));

      await close();
    } catch (err) {
      await cancelarAcao();

      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });
        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    reference.current.setData(data);
  }, []);

  return (
    <>
      <> {/* <> Para confirmação do form */}
        <AprovarFaturametoDialogGFE
          id="ringtone-menu-confirmar"
          keepMounted
          modal="md"
          open={openConfirmationDialogRaw}
          onClose={handleConfirmationDialogRaw}
          valueProp={valueConfirmationDialogRaw}
          mensagem={mensagemConfirmationDialogRaw}
          titulo={tituloConfirmationDialogRaw}
          data={faturas}
          separadas={units}
          empenho={empenho}
          username={username}
          password={password}
          textoBtnOK="Aprovar faturamento"
          textoBtnCancel="Cancelar"
        />
      </> {/* <> Para confirmação do form */}

      <S.Wrapper>
        <S.FormWrapper ref={reference} initialData={data} onSubmit={(event) => handleSubmitPegunta(event)}>
          <S.WrapperCab>
            <Input
              name="empenho"
              label="Empenho"
              required
              size="medium"
              getValue={setEmpenho}
            />
            <Input
              name="username"
              label="Login"
              required
              size="medium"
              getValue={setUsername}
            />
            <Input
              type="password"
              name="password"
              label="Senha"
              required
              size="medium"
              getValue={setPassword}
            />
          </S.WrapperCab>

          <ListTransfer
            search
            grid
            dense
            cells={cells}
            url="radadmdadosfaturamentoseplag"
            label="orga_nome"
            unique="fatu_codigo"
            leftTitle="Faturas dos órgãos"
            rightTitle="Faturas que serão geradas"
            onCallback={(value) => setUnits(value)}
            maxHeight={330}
            reset={isEmpty(units)}
            query={{
              wherefield: ['fatu_status'],
              valuewherefield: ["201, 202"],
              typewherefield: ['IN'],
            }}
            showCount
          />
        </S.FormWrapper>
      </S.Wrapper>
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
  cancelarAcao: PropTypes.func.isRequired,
};
